import { connect } from 'react-redux'

const mapStateToProps = ({appConfig: {nodeEnv}}) => ({nodeEnv})
const withRedux = connect(mapStateToProps)

export default withRedux
